import { IBetFailFilters } from '@/types';
import { BetFailItem } from '@/models/betFail';

export const useBetFailStore = defineStore('betFail', () => {
    const items = ref<BetFailItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);

    const filters = reactive<IBetFailFilters>({
        date: [new Date(), new Date()],
        bookmakerId: null,
        botId: null,
        tradingTypeId: null,
        orderId: '',
    });

    const isExtraFiltersDisplayed = ref<boolean>(false);

    return {
        items,
        total,
        loading,
        filters,
        isExtraFiltersDisplayed,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useBetFailStore, import.meta.hot));
}
